import { REVIEWS_TAB_TITLE } from './constants'
import { isDefined } from 'helpers/utils'
import { BIG_O_MILEAGE_WARRANTY } from 'constant'
import { isNumericWarranty } from 'components/common/WarrantyBadge/helpers'

export const tabsConfig = (reviewsCount, bvId) => [
  { title: 'Overview' },
  ...(bvId ? [{
    title: isDefined(reviewsCount) ?
      `${REVIEWS_TAB_TITLE} (${reviewsCount})` :
      REVIEWS_TAB_TITLE
  }] : [])
]

export const getWarrantyName = originalName =>
  originalName === BIG_O_MILEAGE_WARRANTY ? 'Mileage Warranty' : originalName

export const hasNumericWarranty = (warranties = []) =>
  warranties.some(({ warrantyValue }) => isNumericWarranty(warrantyValue))

export const isFeaturesOrBenefits = (features = [], benefits = []) =>
  Boolean(features.length) || Boolean(benefits.length)

